// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#viewer {\r\n  background-color: black;\r\n  width: 100%;\r\n}\r\n\r\n.loadingTextDiv {\r\n  color: var(--text-secondary-color);\r\n  font-size: 30px;\r\n}\r\n.header{\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  color: #fff;\r\n  -webkit-box-align: center;\r\n      -ms-flex-align: center;\r\n          align-items: center;\r\n}\r\n", ""]);
// Exports
module.exports = exports;
